import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { ModalDataArrived } from 'src/app/models/modal-data.model';

import * as XLSX from 'xlsx';

@Component({
  selector: 'app-modal-arrived-data',
  templateUrl: './modal-arrived-data.component.html',
  styleUrls: ['./modal-arrived-data.component.scss']
})
export class ModalArrivedDataComponent implements OnInit {

  displayedColumns: string[] = ['organization_name', 'product_name', 'status', 'previous_state', 'date'];

  constructor(
    public dialogRef: MatDialogRef<ModalArrivedDataComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { title: string, arrivedData: any[] }
  ) { }

  ngOnInit(): void {
    // Aquí tienes acceso directo a la lista de organizaciones enviada desde la página
    console.log('Data cargada en modal:', this.data);
  }

  downloadExcel(): void {
    if (!this.data || !this.data.arrivedData || this.data.arrivedData.length === 0) {
      console.warn('No hay datos disponibles para exportar.');
      return;
    }

    // Convierte el arreglo de objetos (arrivedData) a una hoja de Excel
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.data.arrivedData);
    
    // Crea un libro de trabajo (Workbook) nuevo
    const workbook: XLSX.WorkBook = XLSX.utils.book_new();
    
    // Añade la hoja al libro (puedes nombrar la pestaña del Excel)
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Datos Arribados');

    // Genera el archivo y dispara la descarga en el navegador
    const nombreArchivo = `${this.data.title.replace(/\s+/g, '_')}_export.xlsx`;
    XLSX.writeFile(workbook, nombreArchivo);
  }

  close(): void {
    this.dialogRef.close();
  }
}